import tx from '@/utils/tx';

export function checkSSOState(){
  return tx.get('/sso/check');
}

export function loadCurrentUserInfo() {
  return tx.get('/sso/user');
}

export function ssoLoginUrl(returnUrl) {
  return tx.get(`/sso/login?rtn=${returnUrl||''}`);
}

export function ssoLogoutUrl(){
  return tx.get('/sso/logout');
}

export function ssoLoginUrlKorus() {
  return tx.get('/sso/login/korus');
}

export function loginInfo(userId, password){
  const paramObj = { userId, password };
  return tx.post('/auth/logininfo', paramObj);
}

export function clearUserInfo(){
  return tx.get('/auth/clear');
}

export function findIdFromPhone(userNm, value){
  const paramObj = { userNm, value };
  return tx.post('/auth/findId/check/phone', paramObj);
}

export function findIdFromEmail(userNm, value){
  const paramObj = { userNm, value };
  return tx.post('/auth/findId/check/email', paramObj);
}

export function findPwFromPhone(userId, value){
  const paramObj = { userId, value };
  return tx.post('/auth/findPw/check/phone', paramObj);
}

export function findPwFromEmail(userId, value){
  const paramObj = { userId, value };
  return tx.post('/auth/findPw/check/email', paramObj);
}

export function findPwVerify(verify, code){
  const paramObj = { verify, code };
  return tx.post('/auth/findPw/proc', paramObj);
}

export function changePw(password){
  const paramObj = { password };
  return tx.post('/auth/pwchange', paramObj);
}

export function req2nd(){
  return tx.get('/2nd/req');
}

export function getResult2nd(){
  return tx.get('/2nd/result');
}

export function checkOpt2nd(otp){
  const paramObj = { otp };
  return tx.post('/2nd/otp', paramObj);
}
